import React from "react";
import { Outlet } from "react-router-dom";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import ScrollToTopArrow from "../../../components/ScrollToTopArrow";
import WhatsAppHelpSection from "../WhatsAppHelpSection/WhatsAppHelpSection";

const Layout = () => {
  return (
    <div className="site-wrapper">
      <Header />
      <main className="main-content">
        <Outlet />
      </main>
      <Footer />
      <ScrollToTopArrow />
      <WhatsAppHelpSection onlyFloating={true} />
    </div>
  );
};

export default Layout;
